import type { ReactNode } from 'react';

interface ProgressBarProps {
  value: number;
  total: number;
  /** Texto que acompana a la barra. Sin el, el avance solo se veria en color. */
  label: string;
}

/**
 * Avance de una lista de trabajo.
 *
 * Lleva siempre el recuento escrito al lado. La barra sirve para ver de un
 * vistazo cuanto falta; quien no distingue los tonos, o mira el telefono al
 * sol, lee el numero.
 */
export function ProgressBar({ value, total, label }: ProgressBarProps): ReactNode {
  const percent = total > 0 ? Math.round((value / total) * 100) : 0;

  return (
    <div>
      <div className="flex items-baseline justify-between gap-2 text-sm">
        <span className="text-muted">{label}</span>
        <span className="font-medium tabular-nums text-content">
          {value} de {total}
        </span>
      </div>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={value}
        aria-label={label}
        className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-primary-soft"
      >
        <div
          className="h-full rounded-full bg-accent transition-[width] duration-300"
          style={{ width: `${String(percent)}%` }}
        />
      </div>
    </div>
  );
}
